/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  DownloadIcon,
  EyeIcon,
  IconButton,
  MicroLabel,
} from "../ui/tables/tableUi";

const Accordion = ({ title, data, onDownload, onView }: any) => {
  const { t } = useTranslation();
  const [active, setActive] = useState(false);

  const toggleAccordion = () => {
    setActive(!active);
  };

  // Fonction pour sécuriser l'affichage des données
  const safeDisplay = (value: any, defaultValue: string = "—") => {
    if (value === null || value === undefined || value === "")
      return defaultValue;
    return String(value);
  };

  // Fonction pour formater le montant de manière sécurisée
  const formatAmount = (amount: any) => {
    if (amount === null || amount === undefined) return "—";
    const numAmount = parseFloat(amount);
    if (isNaN(numAmount)) return "—";
    return `${numAmount} €`;
  };

  return (
    <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
      <button
        type="button"
        onClick={toggleAccordion}
        aria-expanded={active}
        className="flex w-full cursor-pointer items-center justify-between gap-3 px-4 py-3 text-left transition-colors hover:bg-slate-50 focus-visible:ring-2 focus-visible:ring-indigo-200 focus-visible:outline-none"
      >
        <span className="flex min-w-0 items-center gap-2">
          <span className="truncate font-Nunito text-sm font-bold text-slate-900 sm:text-base">
            {title}
          </span>
          <span className="rounded-full bg-slate-100 px-2 py-0.5 font-Nunito text-xs font-semibold text-slate-500 tabular-nums">
            {data.length}
          </span>
        </span>

        <svg
          aria-hidden="true"
          className={`size-4 shrink-0 text-slate-400 transition-transform duration-200 ${
            active ? "rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          strokeWidth={2.2}
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {active && (
        <div className="border-t border-slate-100 p-3">
          {data.length > 0 ? (
            <ul className="flex flex-col gap-2">
              {data.map((item: any) => (
                <li
                  key={item.id}
                  className="rounded-xl border border-slate-200 bg-slate-50/60 p-3"
                >
                  <div className="flex flex-wrap items-start justify-between gap-3">
                    <div className="min-w-0 flex-1">
                      <p className="font-Nunito text-sm font-semibold wrap-break-word text-slate-900">
                        {safeDisplay(item.documentName)}
                      </p>

                      <dl className="mt-2 grid grid-cols-2 gap-x-3 gap-y-2 sm:grid-cols-3">
                        <div>
                          <dt>
                            <MicroLabel>{t("Date")}</MicroLabel>
                          </dt>
                          <dd className="mt-0.5 font-Nunito text-sm text-slate-600">
                            {safeDisplay(item.date)}
                          </dd>
                        </div>
                        <div>
                          <dt>
                            <MicroLabel>{t("Montant")}</MicroLabel>
                          </dt>
                          <dd className="mt-0.5 font-Nunito text-sm text-slate-600 tabular-nums">
                            {formatAmount(item.totalAmount)}
                          </dd>
                        </div>
                        <div>
                          <dt>
                            <MicroLabel>{t("Taille")}</MicroLabel>
                          </dt>
                          <dd className="mt-0.5 font-Nunito text-sm text-slate-600">
                            {safeDisplay(item.documentSize)}
                          </dd>
                        </div>
                      </dl>
                    </div>

                    <div className="flex shrink-0 items-center gap-1.5">
                      <IconButton
                        label={t("Visualiser")}
                        tone="cyan"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (onView) {
                            onView(item);
                          }
                        }}
                      >
                        <EyeIcon />
                      </IconButton>
                      <IconButton
                        label={t("Télécharger")}
                        tone="blue"
                        onClick={(e) => {
                          e.stopPropagation();
                          onDownload(item);
                        }}
                      >
                        <DownloadIcon />
                      </IconButton>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <p className="px-1 py-3 font-Nunito text-sm text-slate-500">
              {t("Aucun document disponible")}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default Accordion;
